import oracle from "@/utils/oracle";

let language = {
    lang(input) {
        if (oracle.isEN()) {
            return input
        }
        let dictionary = {
            'System will verify your information and you will receive an email regarding your request. Please wait for 12 working hours.':"سیستم اطلاعات شما را تایید می کند و ایمیلی در رابطه با درخواست شما دریافت خواهید کرد. لطفا 12 ساعت کاری صبر کنید.",
            "Passenger": "مسافر",
            "Confirmation service via"  :"سرویس دریافت تاییده",
            "Submit a request for reservation trial" :"ارسال درخواست دریافت تاییدیه",
            "In order to present to the embassy" :"جهت ارائه به سفارت",
            "First, put the link of your desired accommodation through Booking.com in the box below."   :"ابتدا لینک محل اقامت مورد نظر خود را از طریق سایت Booking.com در باکس پایین قرار دهید.",
            "The address must start with https://www.booking.com.":"آدرس میبایست با https://www.booking.com شروع شود.",
            "Enter your email.":"ایمیل خود را وارد نمایید.",
            "Add Passenger": "افزودن مسافر",
            "Remove Passenger": "حذف مسافر",
            "If the documents are approved, you will be contacted by email." :"در صورت تایید مدارک از طریق ایمیل با شما مکاتبه خواهد شد.",
            "Enter passenger details." :"مشخصات مسافران را وارد نمایید.",
            "The first page of the passport in PDF, PNG, JPEG format":"صفحه اول پاسپورت به صورت PDF, PNG, JPEG",
            "Passport ID":"شناسه پاسپورت",
            "Latin name and surname (as per passport)" :"نام و نام خانوادگی لاتین (مطابق پاسپورت)",
            "Explanations related to the day and time of Check-IN, as well as points to be considered during the reservation." :"توضیحات مربوط به روز و ساعت Check-IN و همچنین نکاتی که باید در حین رزرویشن مورد توجه قرار بگیرد.",
            "Please complete the description of the request based on the status of the Booking.com link." :"لطفا متن توضیحات درخواست را بر اساس وضعیت لینک Booking.com تکمیل نمایید.",
            "If the information is entered correctly, register your request.":"در صورتی که اطلاعات به درستی وارد شده است، درخواست خود را ثبت کنید.",
            "Refugee": "پناهندگی",
            'Attachment (Resume/CV)': 'ضمیمه (رزومه)',
            'Client has been created successfully and will be shown after review by the administrator.': 'متقاضی با موفقیت ثبت گردید و پس از تایید مدیریت نمایش داده خواهد شد.',
            'Client\'s First name and last name': 'نام و نام خانوادگی متقاضی',
            'Client\'s Email or 11 digits phone number': 'شماره همراه 11 رقمی و یا ایمیل متقاضی',
            'Create a new client': 'ایجاد متقاضی جدید',
            'Create a new client if it is not exists in our database.': 'در صورتی که متقاضی در در سامانه ثبت نباشد، کاربر جدید تشکیل خواهد شد.',
            'Attachment or title of the file is missing': 'فایل ضمیمه و یا نام فایل ضمیمه وارد نشده است',
            'Change password': 'تغییر رمز عبور',
            'Enter your new password and confirm it.': 'رمز عبور جدید خود را وارد نمایید.',
            'RESET PASSWORD': 'تغییر رمز عبور',
            'Request password reset': 'درخواست تغییر رمز عبور',
            'total contract price': 'مبلغ کل قرارداد',
            'paid amount': 'مبلغ پرداخت شده',
            'current installment': 'شماره قسط فعلی',
            'Service price': 'مبلغ خدمت',
            'Percent of retainer amount (eg: 30)': 'درصد مقدار نگهدارنده (مثلا:  30)',
            'Does the service have refund policy?': 'آیا سرویس دارای سیاست بازپرداخت است؟',
            'How many payment installments?': 'چند اقساط پرداختی؟',
            'Time to submit application': 'زمان ارائه درخواست',
            'Additional details': 'توضیحات بیشتر',
            'Choose the service': 'انتخاب سرویس',
            'Save': 'ذخیره',
            'Delete': 'حذف',
            'Choose your special Service': 'سرویس ویژه خود را انتخاب کنید',
            'How it works': 'بیشتر بخوانید',
            'Get Started!': 'شروع کنید!',
            'Login with password': 'با رمز عبور وارد میشوید؟',
            'Download': 'ذخیره',
            'Upload an attachment': 'آپلود فایل ضمیمه',
            'Attachment:': 'فایل ضمیمه:',
            'Attachment': 'فایل ضمیمه',
            'Add attachment': 'افزودن ضمیمه',
            'Attachment title': 'عنوان ضمیمه',
            '(Uploaded by client)': '(آپلود شده توسط متقاضی)',
            '(Uploaded by consultant)': '(آپلود شده توسط مشاور)',
            'Attachments': 'اسناد و فایل ضمیمه پرونده',
            'Save attachments': 'ذخیره اسناد',
            'Manage Attachments': 'مدیریت اسناد و فایل ضمیمه',
            'Other consultants': 'سایر مشاورین',
            'The RCIC is not available now. You may contact other consultants': 'مشاور مورد نظر در حال حاضر قادر به پاسخگویی نیست. شما می توانید با سایر مشاورین ارتباط بگیرید.',
            'Enter your email address to receive the new temporary password': 'لطفا آدرس ایمیل خود را جهت دریافت رمز یکبار مصرف وارد نمایید',
            'User Dashboard': 'ورود کاربران',
            'In Canadian Dollars': 'به دلار کانادایی',
            'In Dollars': 'به دلار',
            'Contract has been updated successfully.': 'پرونده با موفقیت بروزرسانی شد.',
            'Edit payment Details': 'ویرایش اطلاعات پرداخت',
            'Total contract price:': 'کل مبلغ قرارداد:',
            'Consultant share:': 'سهم مشاور:',
            'Consultant received share:': 'مبلغ پرداخت شده از سهم مشاور:',
            'Current installment:': 'شماره قسط فعلی:',
            'Paid amount:': 'مبلغ پرداخت شده:',
            "Contract has been created successfully, you can now modify it under 'Clients'.": "پرونده با موفقیت تشکیل شد، هم اکنون میتوانید در بخش 'پرونده ها'، آن را مدیریت نمایید.",
            'Client': 'متقاضی',
            'Select the plan type': 'نوع پلن را مشخص کنید',
            'Reset password': 'بازیابی رمز عبور',
            'FORGET PASSWORD': 'فراموشی رمز عبور',
            'Forget your password?': 'رمز عبور خود را فراموش کرده اید؟',
            'Canadian Dollars': 'دلار کانادایی',
            'Dollars': 'دلار',
            'day(s)': 'روز',
            'Save contract': 'ذخیره پرونده',
            'create contract': 'تشکیل پرونده',
            'percent from contract': 'درصد از قرارداد',
            'part(s)': 'قسط',
            'Only Verified Consultants': 'نمایش مشاورین رسمی',
            'Office in Canada': 'دفتر مستقر در کانادا',
            'Office in Iran': 'دفتر مستقر در ایران',
            'Filter Consults:': 'فیلتر مشاورین:',
            'Enter number of days (eg: 365)': 'مدت قرارداد به روز (مثلا: 365)',
            'Enter number of Installments (eg: 2)': 'تعداد قسط را وارد کنید (مثلا: 2)',
            'Percent of contract price (eg: 30)': 'درصد از مبلغ قرارداد دلار کانادا (مثلا:  30)',
            'Click here': 'کلیک کنید',
            'Are you a consultant?': 'آیا مشاور هستید؟',
            'No reply': 'بدون پاسخ',
            'Cancel': 'رد شده',
            'Contract': 'منجر به قرارداد',
            'Has Plan': 'پرونده دارد',
            'Visits': 'متقاضیان',
            'Investment and Business Visas': 'سرمایه گذاری و راه اندازی بیزینس',
            'Work Visas': 'ویزای کار',
            'Visitor & Tourism Visas': 'ویزای توریستی',
            'Study & Training Visas': 'ویزای تحصیلی',
            'Family & sponsorship Visas': 'اسپانسرشیپ اعضای خانواده',
            'PNP': 'برنامه های استانی',
            'Express Entry': 'اکسپرس انتری',
            'ICT': 'انتقال شعبه بیزینس',
            'Owner operator': 'راه اندازی یا خرید بیزنس',
            'Startup visa': 'استارتاپ ویزا',
            'Visitor visa (tourism)': 'ویزای توریستی',
            'Business visitor visa': 'ویزای بازدید تجاری',
            'Express Entry (FSW)': 'اکسپرس انتری (فدرال)',
            'Express Entry (CEC)': 'اکسپرس انتری (تجربه کار کانادایی)',
            'Express Entry (T...) ': 'اکسپرس انتری (حرفه ای)',
            'Work permit': 'ویزای کار',
            'This list is empty': 'موردی ثبت نشده است',
            'Study permit ': 'ویزای تحصیلی',
            'Judicial review ': 'بررسی قضایی',
            'PGWP': 'اجازه کار بعد از تحصیل',
            'Self employed': 'خوداشتغالی (ورزشکاران و هنرمندان)',
            'Care giver program': 'نیروی مراقبت در منزل',
            'PNP entrepreneurship': 'برنامه کارآفرینی استانی',
            'Spousal sponsorship (PR)': 'اسپانسرشیپ همسر',
            'Super Visa': 'سوپر ویزا پدر و مادر',
            'Parents and grandparents sponsorship': 'اسپانسرشیپ پدر (بزرگ) و مادر (بزرگ)',
            'View Evaluation Form': 'مشاهده فرم ارزیابی',
            'Plan:': 'نوع پلان:',
            ' Document(s)': ' پرونده',
            'Create at:': 'ایجاد شده در:',
            'Special Service': 'خدمات',
            'Specializations': 'تخصص ها',
            'Choose your special services': 'سرویس های خود را مشخص کنید',
            'Choose your languages': 'زبان های خود را مشخص کنید',
            'Choose your specializations': 'حیطه تخصص خود را مشخص کنید',
            'Filter your services': 'سرویس های دلخواه را مشخص کنید',
            'Filter your languages': 'زبان های دلخواه را مشخص کنید',
            'Filter your specializations': 'حیطه تخصص دلخواه را مشخص کنید',
            'Free Consultation': 'مشاوره اولیه رایگان',
            'Fast Reply': 'پاسخگویی سریع',
            'Professional Insurance': 'بیمه مسوولیت حرفه ای',
            'Apply status:': 'وضعیت پرونده:',
            'Current status details:': 'توضیحات وضعیت پرونده:',
            'Get in touch': 'برقراری ارتباط',
            'Consultants': 'مشاورین',
            'Save changes': 'ذخیره تغییرات',
            'Brief details about the current progress': 'توضیحات درباره وضعیت فعلی',
            'Set client state': 'وضعیت پرونده را مشخص کنید',
            'Plan Details': 'توضیحات تکمیلی',
            'Plan Duration': 'زمان قرارداد',
            'Plan Price': 'قیمت قرارداد',
            'Plan Installments': 'شرایط پرداخت',
            'Plan Refund': 'بازگشت وجه',
            'Plan Name': 'نام پلن',
            'Submit Plan': 'ثبت پلن',
            'Delete Plan': 'حذف پلن',
            'Edit': 'ویرایش',
            'Company': 'نام شرکت',
            'Iran Location': 'آدرس دفتر ایران',
            'Canada Location': 'آدرس دفتر کانادا',
            'Pick options': 'موارد را انتخاب کنید',
            'Initial Consultation Fee': 'هزینه مشاوره اولیه',
            'Logged In': 'ورود',
            'Cases': 'پرونده ها',
            'Go to my cases': 'مشاهده پرونده های من',
            'Clients': 'پرونده ها',
            'Your apply request received successfully. please contact your consultant directly for more info.': 'پذیرش با موفقیت انجام شد، لطفا جهت کسب اطلاعات بیشتر با مشاور ارتباط بگیرید.',
            'Thank you for your comment, it will be displayed in a few hours.': 'از ثبت نظر شما سپاس گذاریم، پیام شما تا ساعاتی بعد منتشر خواهد شد.',
            'Company name': 'نام شرکت',
            'Office location': 'آدرس دفتر: ',
            'Canada: ': 'کانادا: ',
            'Iran: ': 'ایران: ',
            "Guest!": 'مهمان!',
            'Write a review for this consultant': 'نظر خود را راجع به مشاور بنویسید',
            'Submit Review': 'ارسال نظر',
            'Write a review': 'ثبت نظر',
            'Price: ': 'هزینه: ',
            'Duration: ': 'مدت: ',
            'Refund: ': 'بازگشت وجه: ',
            'Installments: ': 'شرایط پرداخت: ',
            'Details: ': 'توضیحات: ',
            'Apply': 'ثبت درخواست',
            'About Me': 'درباره من',
            'Specialization': 'تخصص ها',
            'Initial Consultation': 'مشاوره اولیه',
            'Languages': 'آشنایی با زبان',
            'Services': 'خدمات',
            ' vote(s)': ' رای دهنده',
            'Licence Verified': 'مشاور رسمی',
            'Search result: ': 'نتیجه جست و جو: ',
            'Overview': 'درباره',
            'Prices': 'لیست قیمت',
            'Reviews': 'نظرات کاربران',
            'rate: ': 'امتیاز: ',
            'Info': 'اطلاعات بیشتر',
            'Video': 'ویدیو',
            'Video gallery': 'ویدیو گالری',
            'Top Videos:': 'ویدیوهای  برتر:',
            'Search videos ...': 'جستجو در ویدیوها ...',
            'All Videos': 'همه ویدیو ها',
            'Enter your valid email address': 'لطفا آدرس پست الکترونیک خود را وارد نمایید',
            'Email Address': 'پست الکترونیک',
            "Consultant's Whatsapp number: ": 'شماره واتس اپ مشاور: ',
            "Support's Whatsapp number: ": 'شماره واتس اپ: ',
            'Share message has been saved in your clipboard, share it with family and friends to get a bonus.': 'متن اشتراک گذاری در کلیپبورد شما ذخیر شد، با اشتراک گذاری متن بین دوستان و همکاران خود اعتبار هدیه بگیرید.',
            'Share and receive bonus': 'اشتراک گذاری کنید و اعتبار هدیه بگیرید',
            'CONFIRMATION': 'تایید و نهایی سازی',
            'Yes, Log me out': 'بله، خارج میشوم',
            'Are you sure to exit?': 'آیا از حساب کاربری خود خارج میشوید؟',
            "Consultant dashboard": "ورود مشاورین",
            "Let's chat": 'شروع مشاوره',
            "Blogs & News": 'اخبار و مقالات',
            "Welcome to Visternet": "به Visternet خوش آمدید",
            'Download App': 'دانلود برنامه',
            'contact us': 'تماس با ما',
            'Licence ID': 'شماره پروانه',
            'Skype Account': 'اکانت اسکایپ',
            'Whatsapp Account': 'اکانت واتس اپ',
            'Telegram Account': 'اکانت تلگرام',
            'Discord Account': 'اکانت دیسکورد',
            'Full Name': 'نام و نام خانوادگی',
            'Change Username': 'تغییر نام کاربری',
            'Change Password': 'تغییر رمز عبور',
            'Facebook Page': 'صفحه فیسبوک',
            'Instagram Page': 'صفحه اینستاگرام',
            'Twitter Page': 'صفحه توییتر',
            'Youtube Page': 'صفحه یوتیوب',
            'Brief Description': 'توضیحات مختصر',
            'Long Description': 'توضیحات طولانی',
            'Click': 'مکاتبه',
            'Comment': 'نظر',
            'Unfortunately your request has been rejected, please contact us for more information.': 'متاسفانه درخواست شما رد شده است، لطفا برای اطلاعات بیشتر با ما تماس بگیرید.',
            'Your request is processing, we will contact you when your registration is completed.': 'درخواست شما در حال بررسی است، پس از تکمیل ثبت نام با شما تماس خواهیم گرفت.',
            "Create an Account": "ایجاد حساب کاربری",
            "Please fill in the form below and we will contact you via email once we process your sign up application.": "لطفا فرم زیر را پر کنید و پس از بررسی درخواست ثبت نام شما از طریق ایمیل با شما تماس خواهیم گرفت.",
            "I dont have an account yet!": "حساب کاربری ندارم",
            "Get connected": "ثبت نام",
            "From the list, select your age.": "از لیست، سن خود را انتخاب کنید.",
            "If you have taken or you are planning to take any English proficiency test, indicate the overall score you received or you can receive. If you are a TOEFL person, please see the score comparison below:\nTOEFL score 35-78 = IELTS band 5 - 6\nTOEFL score 78 and above = IELTS band 6 and above": "اگر شرکت کرده اید یا قصد دارید در هر آزمون مهارت انگلیسی شرکت کنید، نمره کلی را که دریافت کرده اید یا می توانید دریافت کنید، مشخص کنید. اگر شما یک فرد تافل هستید، لطفا مقایسه نمرات زیر را ببینید:\n" +
                "نمره تافل 35-78 = آیلتس باند 5 - 6\n" +
                "نمره تافل 78 به بالا = آیلتس باند 6 و بالاتر",
            "Check the box to indicate the latest education level you achieved.": "برای نشان دادن آخرین سطح تحصیلی که کسب کرده اید، کادر را علامت بزنید.",
            "From the list, select the GPA of your latest education level.": "از لیست، معدل آخرین مقطع تحصیلی خود را انتخاب کنید.",
            "You must have minimum funds needed for different immigration programs. Please specify the minimum amount in CAD": "شما باید حداقل بودجه مورد نیاز برای برنامه های مختلف مهاجرت را داشته باشید. لطفا حداقل مبلغ را به CAD مشخص کنید",
            "In some programs having Canadian work experience, is required. If your work experience is less than 1 year, please chose 'I do not have'.": "در برخی از برنامه ها داشتن تجربه کاری کانادایی الزامی است. اگر سابقه کاری شما کمتر از 1 سال است، لطفاً 'من ندارم' را انتخاب کنید.",
            "Please indicate if you have ever completed any level of education in Canada that is at least 1 academic year. If the duration of your education is less than 1 academic year, please choose 'I do not have'.": "لطفاً مشخص کنید که آیا تا به حال هر سطح تحصیلی را در کانادا به پایان رسانده اید که حداقل 1 سال تحصیلی باشد. اگر مدت تحصیل شما کمتر از 1 سال تحصیلی است، لطفاً 'من ندارم' را انتخاب کنید.",
            "If you are a business owner, entrepreneur or CEO, check the box.": "اگر صاحب کسب و کار، کارآفرین یا مدیر عامل هستید، کادر را علامت بزنید.",
            "Please indicate if you have ever worked as a manager or a supervisor for at least 1 year.": "لطفاً مشخص کنید که آیا تا به حال به عنوان مدیر یا سرپرست برای حداقل 1 سال کار کرده اید یا خیر.",
            "Sign up": "ثبت نام",
            "I want to Sign up": "درخواست عضویت",
            "Case sensitive password": "رمز عبور، حساس به بزرگی و کوچکی حروف",
            "Account username": "نام کاربری",
            "Enter your username and password to log into your account.": "نام کاربری و رمز عبور خود را برای ورود به حساب خود وارد نمایید.",
            "SIGN IN TO YOUR ACCOUNT": "ورود به حساب مشاور",
            "I agree with the": "موافقم",
            "rules and agreements": "با قوانین و مقررات",
            "Type your password again": "تکرار گذرواژه",
            "Your Full name": "نام و نام خانوادگی",
            "Your Phone number": "شماره تلفن همراه با کد کشور",
            "Your Email address": "آدرس ایمیل",
            "Your Licence ID": "شماره لایسنس",
            "Your Office Address": "آدرس دفتر پذیرش (اختیاری)",
            "JOIN OUR TEAM": "پیوستن به تیم ما",
            "Please fill the form below to join the Visternet team. we will get connected to you once we process your resume.": "جهت پیوستن به تیم وکلای visternet لطفا فرم زیر را پر کنید، پس از بررسی فرم شما با شما ارتباط خواهیم گرفت.",
            "Male": "مرد",
            "Discard": "انصراف",
            "Set Profile": "ثبت تغییرات",
            "Female": "زن",
            "Bio": "بیوگرافی",
            "Email": "پست الکترونیک",
            "username": "نام کاربری",
            "Birthday": "تاریخ تولد",
            'Enter your mobile number in correct digits': 'شماره خود را به صورت صحیح وارد کنید',
            "Quick assessment tool": "ارزیابی سریع و رایگان",
            "Share": "اشتراک گذاری",
            'Passwords do not match': 'رمز عبور یکسان نیست',
            'Password can not be empty': 'رمز عبور صحیح نیست',
            'Username can not be empty': 'نام کاربری صحیح نیست',
            "Use our free online assessment tool to check your eligibility and find the program that matches your profile in less than 1 minute.": "با یک کلیک و در کمتر از یک دقیقه شرایط خود را برای مهاجرت به کانادا ارزیابی کنید و برنامه مهاجرتی مناسب خود را پیدا کنید.",
            "Easy access from any where in the world": "مشاور مهاجرت شما باید قانونی و مطمئن باشه!",
            "Access consultants who are regulated and licensed by the government of Canada to help you with your Canadian immigration application.": "اینجا می تونید از قانونی بودن و رسمی بودن مشاور مهاجرت خود اطمینان حاصل کنید. تنها مشاوران رسمی مجاز به انجام امور مهاجرت شما به کانادا هستند.",
            "Save time and money": "صرفه جویی در زمان و هزینه ها",
            "Your time and hard earned money is more valuable. Here, at Visternet you can see all consultants profiles and their expertise in just one click.": "دیگه نیازی نیست برای پیدا کردن یک مشاور یا مشاور رسمی و قانونی، هزینه و زمان زیادی صرف کنید. در ویزترنت با یک کلیک، شرایط و تخصص مشاورین مختلف رو بررسی و مشاور مورد نظرتون رو انتخاب کنید.",
            "Get Started": "شروع کنید",
            "Log out": "خروج از حساب",
            "HOW IT WORKS?": "چطور از ویزترنت استفاده کنم؟",
            "Follow the below steps to get connected with regulated consultants.": "هدف ما اینه که فرایند مهاجرت شما رو تا جای ممکن ساده تر و مطمئن تر کنیم.",
            "Check your eligibility using our free tool": "خیلی سریع و رایگان شرایط خودت رو برای مهاجرت به کانادا ارزیابی کن!",
            "Find a regulated immigration consultant": "مشاور رسمی و قانونی خودت را انتخاب کن!",
            "Get their advice and prepare your Visa application": "راهنمایی های لازم رو بگیر و مدارکت رو برای درخواست ویزا فراهم کن!",
            "Get ready to travel to Canada": "بلیطت رو بگیر و آماده سفر شو!",
            "DID YOU KNOW?": "می دونستید؟",
            "Only representatives authorized and licensed by the government of Canada are allowed to evaluate your Visa application and submit it on your behalf. If you choose a paid representative who’s not authorized by the government of Canada, they may return your application or refuse it.": "می دونستید که تنها مشاورین و وکلای مورد تایید اداره مهاجرت کانادا اجازه دارند که امور مهاجرت شما و ارسال مدارک شما به اداره مهاجرت رو انجام بدهند. اگر مشاور شما رسمی نبوده و مورد تایید دولت کانادا نباشد، همین مساله می تواند باعث برگشت یا رد شدن پرونده مهاجرتی شما شود",
            "WHAT OUR USERS EXPERIENCED": "تجربه همکاری با ما",
            "Whether you’re a person looking for the right immigration pathway to Canada or an Agency in the need of an experienced consultant, we are here to support you.": "اگر شما هم جزء افرادی هستید که می خواید از روش درست به کانادا مهاجرت کنید یا موسسه ای هستید که به خدمات یک مشاور رسمی مهاجرت به کانادا احتیاج دارید، ما اینجاییم که به شما کمک کنیم. با ما در ارتباط باشید.",
            "Partner with us today!": "همکاری با ما",
            "1. Send a request": "۱. ارسال درخواست",
            "Send us your request via email at partnership@visternet.com.": "برای همکاری، لطفا درخواست خود را از طریق دکمه واتس اپ یا ایمیل به ادرس partnership@visternet.com ارسال کنید.",
            "2. Get connected to our team": "۲. تیم‌ ما با شما ارتباط می‌ گیرند.",
            "A designated personal will get back to you within 48 hours.": "یکی از اعضای تیم ما برای دریافت اطلاعات بیشتر با شما در ارتباط خواهد بود.",
            "3. Let's get successful": "۳. برای موفقیت آماده ای؟",
            "Let’s create a better experience for people and grow.": "رشد کسب و کار شما و کمک به افراد برای تحقق رویای مهاجرت شون به کانادا هدف ماست. به جمع بزرگ‌ ما خوش آمدید.",
            "Learn more about us": "درباره ما بیشتر بدانید",
            "Try": "ارزیابی",
            "Please read and sign rules and agreements": "لطفا قوانین و مقررات را مطالعه نموده و در صورت موافقت تیک را لمس کنید",
            "Visa types:": "انواع ویزا:",
            "Terms did not matched": "شرایط مطابقت نداشت",
            "Congrats!": "تبریک!",
            "Finalize form": "نتیجه فرم",
            "Enter your username to receive the new temporary password": "برای دریافت کد تایید موقت نام کاربری خود را وارد کنید",
            "Enter your mobile number or email address to receive the confirmation code": "برای دریافت کد تایید شماره موبایل یا ایمیل خود را وارد کنید",
            "LOGIN": "ورود به حساب کاربری",
            "I already have an account": "من یک اکانت از قبل دارم",
            "Register and continue": "ثبت نام کنید و ادامه دهید",
            "REGISTER": "عضویت",
            "Enter your name and phone number or email address to register, If you already registered log in": "نام، شماره تلفن و یا ایمیل خود را برای ثبت نام وارد کنید، اگر قبلا ثبت نام کرده اید وارد شوید",
            "Next Step": "گام بعد",
            "Previous Step": "گام قبل",
            "Fill and continue": "پر کنید و ادامه دهید",
            "done": "اتمام",
            "done_all": "اتمام همه",
            "Most Visited:": "بیشترین بازدید:",
            "All Articles": "همه مقالات",
            "Search articles and news ...": "جستجو در مقالات و اخبار ...",
            "Top Articles:": "مقالات برتر:",
            "Share on social media:": "اشتراک گذاری در شبکه های اجتماعی: ",
            "Search consultants ...": "جستجوی مشاور ... ",
            "All consultant": "همه مشاوران",
            'My Dashboard': 'داشبرد من',
            "Sign In": "ورود",
            'Account Manager': 'مدیریت حساب',
            "Find a consultant": "جستجوی مشاور",
            "Terms of use": "شرایط استفاده",
            "Read more articles": "مقالات بیشتری را بخوانید",
            "Try again": "ارزیابی مجدد",
            "Select and finalize": "انتخاب پلن",
            "Select this plan": "انتخاب این پلن",
            "Continue if you want to select and Finalize.": "جهت انتخاب پلن ادامه دهید",
            "Couldn't find the page": "صفحه مورد نظر یافت نشد",
            "Gender": "جنسیت",
            "Welcome": "خوش آمدید",
            "File status: ": "وضعیت پرونده: ",

            "Review the case and decide whether to take action again": "بررسی پرونده و تصمیم گیری در خصوص اقدام دوباره",
            "Preparation of accommodation and arrangements for arrival": "تهیه محل اقامت و مقدمات ورود",
            "Ticket purchase": "تهیه بلیط",
            "Send a passport to get a visa": "ارسال پاسپورت برای دریافت ویزا",
            "Get a visa result": "دریافت نتیجه ویزا",
            "Get the result of fingerprinting": "دریافت نتیجه انگشت نگاری",
            "Determine the time of fingerprinting": "تعیین زمان انگشت نگاری",
            "Receive a fingerprint letter": "دریافت نامه انگشت نگاری",
            "Send documents to the Immigration Office to obtain a visa": "ارسال مدارک برای اخذ ویزا به اداره مهاجرت",
            "Sending the required documents for the visa by the client": "ارسال مدارک مورد نیاز برای ویزا توسط مشتری",
            "Pay the second installment": "پرداخت قسط دوم",
            "Receive approvals and acceptance": "دریافت تاییدیه ها و پذیرش",
            "Ongoing case": "پرونده در حال انجام",
            "Receipt and approval of documents by a consultant": "دریافت و تایید مدارک توسط مشاور",
            "Sending the required documents for the desired immigration program by the user":
                "ارسال مدارک مورد نیاز برای برنامه مهاجرتی مورد نظر توسط کاربر",
            "signing agreement": "امضای قرارداد",
            "Pay the first installment": "پرداخت قسط اول",
            "Send initial documents by the user": "ارسال مدارک اولیه توسط کاربر",
            "Select a immigration consultant": "انتخاب مشاور و مشاور مهاجرت",

            "No down payment": "بدون پیش پرداخت",
            "Credits:": "اعتبار:",
            "App sharing": "اشتراک گذاری برنامه",
            "Login and register": "ورود و ثبت نام",
            "My profile": "پروفایل من",
            "Create a ticket": "ایجاد تیکت",
            "Consulting with support": "مشاوره با پشتیبانی",
            "Support": "پشتیبانی",
            "Consult with a consultant": "مشاوره با مشاور",
            "Send voice": "ارسال صدا",
            "About a consultant": "درباره مشاور",
            "Article": "مقاله",
            'Visa Info': 'اطلاعات ویزا',
            'consultant Info': 'اطلاعات مشاور',
            "My advice": "مشاوره های من",
            "Form Result": "نتیجه ارزیابی فوری",
            "Discover immigration programs": "ارزیابی فوری",
            "Login to VISTERNET": "ورود به VISTERNET",
            "Home": "خانه",
            "Immigration content": "مطالب مهاجرت",
            "Go to Home": "رفتن به صفحه اصلی",
            "This page was not found, please check again": "این صفحه یافت نشد، لطفا مجددا بررسی نمایید",
            "You have no transaction": "تراکنشی ندارید",
            "Consulting": "مشاوره",
            "Completing documents": "درحال تکمیل مدارک",
            "Reject the request": "رد درخواست",
            "Terminated": "خاتمه یافته",
            "has been answered": "پاسخ داده شده",
            "Pending": "درحال بررسی",
            "Profile": "پروفایل",
            "Eligibility": "ارزیابی",
            "consultation": "مشاوره",
            "Blog": "مقالات",
            'Please contact the support team if you forget your password': 'لطفا جهت دریافت رمز عبور جدید با پشتیبانی تماس حاصل فرمایید',
            "confirm request": "تایید درخواست",
            "Create a new ticket": "ایجاد تیکت جدید",
            "Click here to view the ticket": "برای مشاهده تیکت اینجا را لمس کنید",
            "You have not created a ticket yet. To create a ticket, touch the Create New Ticket button ":
                "هنوز تیکتی ایجاد نکرده اید برای ایجاد تیکت دکمه ایجاد تیکت جدید را لمس کنید",
            "Visit": "بازدید",
            "If migrating with your spouse, touch": "در صورت مهاجرت با همسر، لمس نمایید",
            "If you want to immigrate with your spouse, check the immigration requirements again by completing the admission form for your spouse.":
                "در صورتی که مایل به مهاجرت با همسر خود میباشید، با تکمیل ارزیابی فوری برای همسر خود شرایط مهاجرت را مجددا بررسی نمایید.",
            "Credits earned": "اعتبار کسب شده",
            "Invitation used": "دعوت استفاده شده",
            "Number of invitations": "تعداد دعوت",
            'Your request has been received, please wait for our support team to contact you.': 'درخواست شما دریافت شد، منتظر تماس پشتیبانی باشید.',
            'Enter your username to contact support': 'نام کاربری خود را جهت دریافت پشتیبانی وارد کنید',
            'Confirmation password has been sent successfully': 'رمز تایید با موفقیت ارسال شد',
            "Copy Referal Code": "کپی کردن متن اشتراک",
            "Get free credit by sending a referral code to your friends and colleagues": "با ارسال کد معرفی به دوستان و همکاران خود، اعتبار رایگان دریافت کنید",
            "The minimum first and last name is 4 letters": "حداقل نام و نام خانوادگی 4 حرف میباشد",
            "Enter your mobile number correctly": "شماره موبایل خود را صحیح وارد نمایید",
            "Enter your mobile number in 11 digits": "شماره موبایل خود را به صورت 11 رقمی وارد نمایید",
            "I do not have an account": "حساب کاربری ندارم",
            "Login to account": "ورود به حساب کاربری",
            "Enter your mobile number": "شماره موبایل خود را وارد کنید",
            "Resend the code": "ارسال مجدد کد",
            "Seconds to resend": " ثانیه تا ارسال مجدد",
            "finalizing": "نهایی سازی",
            "Enter the code sent to your mobile number or email address": "کد ارسالی به شماره همراه و یا ایمیل خود را وارد کنید",
            "I have an account": "حساب کاربری دارم",
            "Register/": "ثبت نام",
            "Phone number": "شماره موبایل",
            "Enter your name and mobile number or email address to register": "جهت ثبت نام , نام، شماره موبایل و یا ایمیل خود را وارد کنید",
            "Edit registration": "ثبت ویرایش",
            "Mobile number": "شماره همراه",
            "My biography": "بیوگرافی من",
            "E-mail": "پست الکترونیک",
            "Date of birth": "تاریخ تولد",
            "First name and last name": "نام و نام خانوادگی",
            "Edit profile": "ویرایش پروفایل",
            "The consultant's number is saved in your clipboard.\nif WhatsApp does not open, please first save the number to your contact and then connect with them via WhatsApp.": "در صورت باز نشدن واتس اپ، ابتدا شماره را در مخاطبین خود ذخیره کرده و سپس در نرم افزار واتس اپ با مشاور مورد نظر ارتباط بگیرید.",
            "The support's number is saved in your clipboard.\nif WhatsApp does not open, please first save the number to your contact and then connect with them via WhatsApp.": "در صورت باز نشدن واتس اپ، ابتدا شماره را در مخاطبین خود ذخیره کرده و سپس در نرم افزار واتس اپ با پشتیبان ارتباط بگیرید.",
            "Send ticket": "ارسال تیکت به واحد پشتیبانی",
            "Select the photo attached to the request": "انتخاب عکس ضمیمه درخواست",
            "Problem text or suggestion ...": "متن مشکل و یا پیشنهاد ...",
            "To make a call and send a message to the VISTERNET support team, enter and send the text of your message so that we can contact you as soon as possible.":
                " برای برقراری تماس و ارسال پیام به تیم پشتیبانی VISTERNET ,متن پیام خود را  وارد کرده و ارسال کنید تا در اسرع وقت با شما مکاتبه شود.",
            "Start counseling": "مشاوره را شروع کنید",
            "Writing text": "نوشتن متن",
            "Your video file size is more than 10 megabytes": "حجم فایل ویدیو شما بیشتر از 10 مگ میباشد",
            "Your photo size is more than 5 mg": "حجم عکس شما بیشتر از 5 مگ میباشد",
            "Communicating.": "در حال برقراری ارتباط.",
            "Select the attachment": " انتخاب فایل ضمیمه",
            "Select the file you want to upload and upload": "فایل مورد نظر را برای بارگزاری و ارسال انتخاب کنید",
            "Send attachment": "ارسال فایل ضمیمه",
            "Write your message": "پیام خود را بنویسید",
            "Touch to run the file": "برای اجرا شدن فایل لمس کنید",
            "file": "فایل",
            "View": "مشاهده",
            "Select the desired language": "زبان مورد نظر را انتخاب کنید",
            "Yes, Im leaving": "بله خارج میشوم",
            "Continue if you want to sign out of your account.": "در صورتی که مایل هستید از حساب کاربری خود خارج شوید، ادامه دهید.",
            "Your current credit": "اعتبار فعلی شما",
            "Account charge amount(Toman)": "مبلغ شارژ حساب (به تومان)",
            "Increase credit": "افزایش اعتبار",
            "Logout": "خروج از حساب كاربری",
            "Change language": "تغییر زبان",
            "Terms and Conditions": "قوانین و مقررات",
            "About us": "درباره ما",
            "About": "درباره ما",
            "Home page": "صفحه اصلی",
            "Contact support": "تماس با پشتیبانی",
            "Contact": "تماس با ما",
            "Send support ticket": "ارسال تیکت پشتیبانی",
            "Financial transactions": "تراکنش مالی",
            "Inbox": "صندوق پیام",
            "introduce to friends": "معرفی به دوستان",
            "User information": "اطلاعات کاربری",
            "Increase in-app credit": "افزایش اعتبار درون برنامه ای",
            "Toman": "تومان",
            "Credit": "اعتبار",
            "Register / Login": "ثبت نام/ ورود به حساب کاربری",
            "Log in to your account to use the features of the program": "برای استفاده از امکانات برنامه وارد حساب کاربری خود شوید",
            "Guest user": "کاربر میهمان",
            "I realized": " متوجه شدم",
            "Start the consultation": "تکمیل ارزیابی فوری و شروع مشاوره",
            "To send the application, enter the admission form section and after completing the form, according to your conditions Receive immigration offers, contact support in case of any problems":
                "جهت ارسال درخواست، وارد بخش ارزیابی فوری شوید و پس از تکمیل فرم، متناسب با شرایط شما پیشنهادات مهاجرت را دریافت نمایید، در صورت هرگونه مشکلی با پشتیبانی ارتباط برقرار نمایید",
            "The request has not been registered": "درخواستی ثبت نشده است",
            "Ask your consultant questions to complete your case review!": "تا تکمیل بررسی پرونده خود، سوالات خود را از مشاور بپرسید!",
            "attached file": "فایل ضمیمه",
            "Video file": "فایل ویدئو",
            "Audio file ": "فایل صدا",
            "Pic file": "فایل تصویری",
            "Advice and viewing records": "مشاوره و مشاهده سوابق",
            "back": "بازگشت",
            "View file status": "مشاهده وضعیت پرونده",
            "Language_Selection": "انتخاب زبان",
            "A beautiful Design System": "لورم ایپسوم متن ساختگی با.",
            "completed with examples": "لورم ایپسوم متن",
            "The design system comes with four pre-built pages to help you get started faster. You can change the text and images and youre good to go.": "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود.",
            "Client Login": " تکمیل ارزیابی فوری و شروع مشاوره",
            "Consultant Login": "مشاهده وکلا و کارشناسان خبره ما",
            "Lorem ipsum dolor sit amet": "مهاجرت سرمایه گذاری",
            "Lorem ipsum dolor sit amet2": "مهاجرت تحصیلی",
            "Lorem ipsum dolor sit amet3": "مهاجرت کاری",
            "Lorem ipsum dolor sit amet4": "ویژگی های کار ما",
            "Argon is a great free UI package based on Bootstrap 4 that includes the most important components and features.": "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد.",
            "Learn more": "بیشتر بدانید",
            "The amazing Team": "تیم حرفه ای ما",
            "Lorem ipsum dolor": "لورم ایپسوم متن.",
            "Lorem ipsum": "لورم ایپسوم",
            "Thank you for supporting us!": "از حمایت شما متشکریم!",
            "Components": "مهاجرت",
            "Lets get in touch": "بیایید با هم در تماس باشیم",
            "Examples": "معرفی خدمات",
            "Landing": "لندینگ",
            "Register": "ورود/عضویت",
            "application ": " اپلیکیشن ",
            "Next step: choose your immigration consultant:": "مرحله بعد: مشاور مهاجرت خود را انتخاب کنید"
        };
        let check = dictionary[input];
        if (check == null) {
            for (let key in dictionary) {
                if (key.toLowerCase().trim() == input.toLowerCase().trim()) {
                    return dictionary[key];
                }
            }
        }
        return check == null ? input : check;
    }
}

export default language